$(".slider-banner").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    cssEase: 'linear'
});
$(".gallery-slider-product").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    arrows: false
});
$(".slider-product-featured").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    arrows: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                arrows: false,
                slidesToScroll: 1,
                dots: false
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                arrows: false,
                slidesToScroll: 1,
                dots: true
            }
        }

    ]
});
$(document).ready(function() {
    var age = {};

    // For use without cookies
  /*  $('#ageModal').modal('show');*/
    initAge();

    // check if cookie for validAge exists..


    // starts the age verification process
    function initAge() {
        var month = 0;
        var day = 0;
        var year = 0;

        $("#age-submit").on("click", function() {
            age['month'] = $("#verify-month").val();
            age['day'] = $("#verify-day").val();
            age['year'] = $("#verify-year").val();
            checkDate();
        });
    }

    // Check to see if user entered a valid date...
    function checkDate() {
        if (age.month == 'none' || age.day == 'none' || age.year == 'none') {
            // Fade in the error...
            $('#modal-error').css('visibility', 'visible').hide().fadeIn('slow');

            // changes the background color of the select if invalid
            if (age.month == 'none') {
                $("#verify-month").css('background', 'rgba(223,32,44,0.5)');
                // Look for change of value and change background color when valid
                $("#verify-month").on('change', function() {
                    if ($("#verify-month").val() == 'none') {
                        $("#verify-month").css('background', 'rgba(223,32,44,0.5)');
                    } else {
                        $("#verify-month").css('background', 'white');
                    }
                });
            }

            // changes the background color of the select if invalid
            if (age.day == 'none') {
                $("#verify-day").css('background', 'rgba(223,32,44,0.5)');
                // Look for change of value and change background color when valid
                $("#verify-day").on('change', function() {
                    if ($("#verify-day").val() == 'none') {
                        $("#verify-day").css('background', 'rgba(223,32,44,0.5)');
                    } else {
                        $("#verify-day").css('background', 'white');
                    }
                });
            }

            // changes the background color of the select if invalid
            if (age.year == 'none') {
                $("#verify-year").css('background', 'rgba(223,32,44,0.5)');
                // Look for change of value and change background color when valid
                $("#verify-year").on('change', function() {
                    if ($("#verify-year").val() == 'none') {
                        $("#verify-year").css('background', 'rgba(223,32,44,0.5)');
                    } else {
                        $("#verify-year").css('background', 'white');
                    }
                });
            }
        } else {
            oldEnough();
        }
    }

    // Compares age entered with todays date 18 years ago...
    function oldEnough() {
        var ageLimit = moment().subtract(18, 'years').calendar();
        var birthDate = age.year + "-" + age.month + "-" + age.day;
        var oldEnough = moment(birthDate, "YYYY-MM-DD").isBefore(ageLimit, 'day');
        if (oldEnough == true) {
            $.cookie('validAge', 'Verification that user is over the legal drinking age in there country', {expires: 7});
            $('#ageModal').modal('hide');
        } else {
            $('#ageModal').modal('show');
            $('.title-modal').text("No se admiten menores de edad");
            $('form').css('visibility', 'hide').hide().fadeOut('slow');
        }
    }
    if (!!$.cookie('validAge')) {
        console.log('a')
        /* $('#ageModal').modal('show');
         $.cookie('validAge', 'Verification that user is over the legal drinking age in there country', {
             expires: 7, //expires in 7 days
         });*/
        return true;
    } else {
        // doesn't exist so lets make them enter a birthday...
        console.log('b')
        $('#ageModal').modal('show');
        /*  $('#ageModal').modal('hide');*/
        initAge();
    }
});
/*

if ($.cookie('validAge') == undefined || $.cookie('validAge') == null) {
    console.log('aaaaaaaa');
    $('#ageModal').modal('show');
    var ageVerificationBtn = document.getElementById('age-submit');
    ageVerificationBtn.addEventListener('click', function (event) {
        console.log('aaaaaaaa');
        $.cookie('validAge', 'Verification that user is over the legal drinking age in there country', {
            expires: 10, //expires in 10 days
        });
        $('#ageModal').modal('hide');
    });
}*/
